import React from "react";
import { DappContextProvider } from "../../contexts/MintContext";
import { 
  CRYPTO_CURRENCY_TICKER,
  MINT_FORM_TITLE,
  MINT_QUANTITY_HELPER_MESSAGE,
  MINT_QUANTITY_MIN,
  MINT_QUANTITY_MAX,
  CRYPTO_CURRENCY_SYMBOL
} from "../../common/constants";
import { randomDisappointment } from "../../common/functions";

export function MintForm(): React.ReactElement {
  const { 
    disableMintButton,
    mintDiscount,
    mintPrice,
    mintQuantity,
    totalMinted,
    maxSupply,
    setMintQuantity,
    setMintSubmit
  } = React.useContext(DappContextProvider);

  function onSubmit(isFreeClaim: boolean, event: React.FormEvent): void {
    event.preventDefault();
    setMintSubmit(true, isFreeClaim);
  }

  function onCancel(): void {
    randomDisappointment();
    setMintQuantity(0);
    setMintSubmit(false, false);
  }

  function mintDiscountMessage(): React.ReactElement {
    if( mintDiscount <= 0 ){
      return <div className="claim-free message"> Sorry, you have no discount: </div>
    }
    return  <div className="claim-free message"> You have a {mintDiscount}% discount: </div>
  }

  return(
    <form 
      className="modal overlay mint-form"
      onSubmit= {(e): void => onSubmit(false, e)}
    >
      <div className="title">
        {MINT_FORM_TITLE}
      </div>
      <div className="row">
          {mintDiscountMessage()}
          <button
            className={"claim-free"}
            onClick={(e): void => onSubmit(true, e) }
            disabled={ mintDiscount <= 0 }
            >
            Claim Discounted
          </button>
      </div>
      <div className="row">
        <div className="multiple wrapper">
          <div className="multiple message">
            How many would you like to mint?
          </div>
          <div className="multiple input-wrapper">
            <div className="count-label"> {mintPrice} {CRYPTO_CURRENCY_TICKER} x </div>
            <input 
              className="count-input"
              type="number"
              min={MINT_QUANTITY_MIN}
              max={MINT_QUANTITY_MAX}
              step={1}
              title={MINT_QUANTITY_HELPER_MESSAGE}
              value={mintQuantity}
              onChange={ (e): void => { setMintQuantity(e.currentTarget.valueAsNumber) }}
              />
              <div className="count-label" > 
                = {mintQuantity * mintPrice} {CRYPTO_CURRENCY_TICKER} 
              </div>
              <img 
                  className={"crypto-symbol"}
                  src= {CRYPTO_CURRENCY_SYMBOL}
                  alt={"crypto-symbol"}
              />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="mint-count">
          {totalMinted} minted / {maxSupply} total supply
        </div>
      </div>
      <div className="row">
        <div className="buttons-wrapper">
          <button
            disabled={ disableMintButton || mintQuantity === 0 }
            className={"submit"}
            type="submit"
            >
            Submit
          </button>
          <button
            className={"cancel"}
            type="button"
            onClick={ onCancel }
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  )
}